import { actions } from "../../../actions/training/courses/courses";

export default function courses( state = {}, action ) {

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_CURRENT_COURSE: return setCurrentCourse( newState, action.course );
        case actions.SET_COURSES: return setCourses( newState, action );
        case actions.SET_COURSE_LOCATIONS: return setCourseLocations( newState, action.locations );
        case actions.SET_CURRENT_COURSE_MODULES: return setCurrentCourseModules( newState, action.modules );
        default: return state;
    }
}

function setCurrentCourse( newState, course ) {
    newState.current_course = course;

    return newState;
}

function setCurrentCourseModules( newState, modules ) {
    newState.current_course_modules = modules;

    return newState;
}

function setCourses( newState, action ) {
    newState.courses = action.courses;
    newState.pagination = action.pagination;

    return newState;
}

function setCourseLocations( newState, locations ) {
    newState.locations = locations;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/training/courses/courses.js